export enum IconSet {
  SOLID = 'fa-solid',
  REGULAR = 'fa-regular',
  LIGHT = 'fa-light',
  THIN = 'fa-thin',
  DUOTONE = 'fa-duotone',
}
